<template>
  <pt-withdraw-audit class="pt-withdraw-audit__page"></pt-withdraw-audit>
</template>

<script>
import PtWithdrawAudit from 'cps/new-to-old-audit/pt-withdraw-audit/withData'
export default {
  name: 'pt-withdraw-audit__view',
  components: {
    'pt-withdraw-audit': PtWithdrawAudit
  }
}
</script>
